export enum ServerErrors {
  PPI_DETECTED = "pii-input-detected",
}

export type TextHighlight = {
  BeginOffset: number;
  EndOffset: number;
};

export type SummaryError = {
  fields?: {
    BeginOffset?: number;
    EndOffset?: number;
    Score?: number;
    Type: string;
  }[];
  kahun_error?: string;
};
